var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:[_vm.$style.image, ( _obj = {}, _obj[_vm.$style.locked] = !_vm.active, _obj )],style:({ backgroundImage: _vm.active ? ("url(" + _vm.image + ")") : null })}),_c('div',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }